/* unplugin-vue-components disabled */import { render } from "./NumericCalculator.vue?vue&type=template&id=72651d13&scoped=true&ts=true"
import script from "./NumericCalculator.vue?vue&type=script&lang=ts"
export * from "./NumericCalculator.vue?vue&type=script&lang=ts"

import "./NumericCalculator.vue?vue&type=style&index=0&id=72651d13&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72651d13"]])

export default __exports__